import React from 'react';
import classes from './PriceTag.css';

const priceTag = (props) => (
  <div className={classes.PriceTag}>
    <h2 className={classes.Price}>${props.price.toFixed(2)}</h2>

  </div>
)



export default priceTag;


// WEBPACK FOOTER //
// ./src/components/UI/PriceTag/PriceTag.jsx